module.exports = __webpack_public_path__ + "static/img/7.e986ec4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/zh/7.png
// module id = kHJw
// module chunks = 0